export default __webpack_public_path__ + "static/media/cmsr.dd2f40eb.png";